// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TruncatedText_tooltip__256q-","tooltip-right":"TruncatedText_tooltip-right__1Q5KD","tooltip-left":"TruncatedText_tooltip-left__1b-G3"};